<div id="popup-camera-pic" class="popup-overlay modal-camera">
  <div class="popup-warp">
      <div class="popup-inner">
          <div class="content-popup pad-popup">
              <p class="text-popup">Căn chỉnh quà tặng vừa khớp khung hình.</p>
              <div class="picture-bill" id="imageContainer">
                <video class="vid" id="video" autoplay loop muted playsinline #video></video>
                <canvas class="canvas hide" id="canvasx" width="720" height="1280" #canvas></canvas>
              </div>
              <div class="group-btn-inline-3">
                <div class="group-btn-inline">
                    <button type="button" class="btn btn-info" id="btn-cancel" [ngClass]="{'disable':!cancelableCamera}" (click)="offCamera()">Hủy</button>
                    
                    <button type="button" class="btn btn-primary btn-camera-custom btn-camera-2"  (click)="captureImage()"><span>Chụp ảnh</span></button>
                </div>
                <button *ngIf="allowUpload"  type="button" class="btn btn-primary btn-block btn-upload" (click)="uploadImage()"><span>Tải lên</span></button>
                <input type="file" (change)="fileChangeEvent($event)" class="fileInputProfile" accept="image/png,image/jpg,image/jpeg" style="display: none;">
                <button type="button" class="btn btn-block btn-link btn-guide-camera" (click)="showGuide = true">Hướng dẫn chụp hoá đơn</button>
            </div>
          </div>
      </div>
  </div>
</div>
<div id="popup-guide-bill" class="popup-overlay-camera modal-confirm guide-bill" [ngClass]="{'hidden':!showGuide}" >
    <div class="popup-warp">
        <div class="popup-inner pad-popup">
            <div class="content-popup">
                <div class="icon-popup"><img src="assets/img/infor-1.png"></div>
                
                    <ul class="list-des des-popup">
                        <li class="bill-true" (click)="showGuide = false; showRightCapture = true;initSwiper();">
                            <span class="number">1</span>
                            <span class="text-des">
                                <strong>Hình ảnh hoá đơn chụp đúng</strong>
                            </span>
                        </li>
                        <li class="bill-fail" (click)="showGuide = false; showWrongCapture = true;initSwiper();">
                            <span class="number">2</span>
                            <span class="text-des">
                                <strong>Hình ảnh hoá đơn chụp sai</strong>
                            </span>
                        </li>
                    </ul>
            </div>
        </div>
    </div>
  </div>

  <div class="popup-overlay modal-default guide-bill" [ngClass]="{'hidden':!showWrongCapture}">
    <div class="popup-warp">
        <div class="popup-inner pad-popup">
            <div class="name-popup">Hình ảnh hoá đơn chụp sai</div>
            <span class="close-popup" (click)="showWrongCapture = false"></span>
            <div class="content-popup">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn bị nhăn, rách</h3>
                            <img src="assets/img/slide1.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn bị tẩy xoá</h3>
                            <img src="assets/img/slide2.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn có chữ viết</h3>
                            <img src="assets/img/slide3.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn có dấu mộc</h3>
                            <img src="assets/img/slide4.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn chụp bị nghiêng</h3>
                            <img src="assets/img/slide5.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn bị mờ</h3>
                            <img src="assets/img/slide6.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hoá đơn chụp trên nền có kí tự</h3>
                            <img src="assets/img/slide7.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title">Hình chụp hoá đơn không rõ chữ</h3>
                            <img src="assets/img/slide8.png" alt="">
                        </div>
        
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
  </div>

  <div class="popup-overlay modal-default guide-bill xxxxx" [ngClass]="{ 'hidden': !showRightCapture }">
    <div class="popup-warp">
        <div class="popup-inner pad-popup">
            <div class="name-popup">Hình ảnh hoá đơn chụp đúng</div>
            <span class="close-popup" (click)="showRightCapture = false"></span>
            <div class="content-popup">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <h3 class="title true">Căn chỉnh hóa đơn vừa khớp khung hình chụp.<br>
                                Bạn có thể chụp nhiều hình nếu hóa đơn dài.</h3>
                            <img src="assets/img/bill-true-1.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title true">Căn chỉnh hóa đơn vừa khớp khung hình chụp.<br>
                                Bạn có thể chụp nhiều hình nếu hóa đơn dài.</h3>
                            <img src="assets/img/bill-true-2.png" alt="">
                        </div>
                        <div class="swiper-slide">
                            <h3 class="title true">Vui lòng gấp hóa đơn lại nếu chụp 2 lần</h3>
                            <img src="assets/img/bill-true-3.png" alt="">
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
  </div>
  <message-popup *ngIf="showMessageBox" [message]="message" (closeEvent)="closeMessagePopupEvent($event)"></message-popup>
  <message-popup *ngIf="cameraIssueVisible" [message]="cameraIssueMessage" (closeEvent)="closeCameraIssue($event)"></message-popup>
  <input 
    type="file" 
    [(ngModel)]="fileObject"
    id="externalCamera" 
    (click)="externalCamera()"
    (change)="externalCameraHandle($event)" 
    accept="image/*" 
    capture>